import React, { createContext, useContext, useState } from 'react';
import axios from 'axios';

const TeamsContext = createContext();

export const TeamsContextProvider = ({ children }) => {
    const [teams, setTeams] = useState(null);

    const getTeams = (token) => {
        axios.get(`https://firewatch-api.space-eyes.com/teams`, {
            headers: { 'Authorization': `Bearer ${token}` }
        }).then((response) => {
            setTeams(response.data.teams)
        }).catch((error) => {
            console.log('error getting teams', error)

        })
    }

    const value = {
        teams,
        setTeams,
        getTeams
    };
  
    return (
        <TeamsContext.Provider 
            value={value}
        >
        {children}
        </TeamsContext.Provider>
    );
};

export const useTeamsContext = () => useContext(TeamsContext);
